import styled from "styled-components";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default function HomepageCardCompletionBar({ percentage, barStyle, ...props }) {
  return (
    <BarContainer {...props}>
      <Progress
        style={barStyle}
        percentage={percentage}
      />
    </BarContainer>
  )
}

const BarContainer = styled.div`
  position: relative;
  height: .25rem;
  background-color: #404042;
  overflow: hidden;
  border-radius: .125rem;
  width: ${themeResponsiveProperty('calc(100% - 2rem)', 'calc(100% - 3rem)')};
  margin: ${themeResponsiveProperty('.125rem 1rem', '.125rem 1.5rem 1rem')};
`;

const Progress = styled.div`
  width: ${(props) => Math.min(100, props.percentage)}%;
  position: absolute;
  inset: 0 auto 0 0;
  background-color: #42CD58;
  border-top-right-radius: .125rem;
  border-bottom-right-radius: .125rem;
`;
